import { Clear, Done } from "@mui/icons-material";
import {
  Grow,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { strongPasswordReqObj } from "utils/utils";

const COMPONENT_LOCALE_KEY = "component.strongPasswordPopper.";

/**
 * @component Popper component for strong password requirments tips
 *
 * @param {Object} props
 * @param {Boolean} props.open
 * @param {import("@mui/material/Popper/BasePopper.types").PopperOwnProps["anchorEl"]} props.anchorEl
 * @param {string|null} props.password
 * @returns
 */
const StrongPasswordPopper = ({ open, anchorEl, password }) => {
  const { t } = useTranslation();
  const xs = useMediaQuery("(max-width: 700px)");

  return (
    <Popper
      id={"password-requirement-popover"}
      open={open}
      anchorEl={anchorEl}
      placement={xs ? "bottom" : "right"}
      modifiers={[
        {
          name: "flip",
          enabled: true,
          options: {
            altBoundary: true,
            rootBoundary: "document",
            padding: 8,
          },
        },
        {
          name: "preventOverflow",
          enabled: true,
          options: {
            altAxis: true,
            // altBoundary: true,
            tether: false,
            rootBoundary: "document",
            padding: 8,
          },
        },
        {
          // offset popper 8px away from input field
          name: "offset",
          options: {
            offset: [0, 8],
          },
        },
      ]}
      transition
      sx={{ zIndex: 1350 }} //Modal z-index is 1300
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper sx={{ px: 3, py: 2 }}>
            <Stack gap="4px">
              <Typography variant="content">
                {t(COMPONENT_LOCALE_KEY + "title")}
              </Typography>
              {Object.entries(strongPasswordReqObj).map(([req, regex]) => {
                const isValidPassword = regex.test(password ?? "");
                return (
                  <Stack
                    direction="row"
                    gap="4px"
                    alignItems="center"
                    key={req}
                  >
                    {isValidPassword ? (
                      <Done color="success" fontSize="12px" />
                    ) : (
                      <Clear color="error" fontSize="12px" />
                    )}
                    <Typography
                      variant="content"
                      color={isValidPassword && "#AAA"}
                      sx={{ transition: "color 0.3s ease" }}
                    >
                      {t(COMPONENT_LOCALE_KEY + req)}
                    </Typography>
                  </Stack>
                );
              })}
            </Stack>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default StrongPasswordPopper;
